import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Events.css'
import './MyEvents.css'
import backgroundImage from './Events/assets/Gemini_Generated_Image_gniijagniijagnii.png'

/**
 * Formats ISO date string to human-readable format
 */
const formatDate = (isoString) => {
  try {
    const date = new Date(isoString + 'T00:00:00')
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', isoString)
      return 'Invalid Date'
    }
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  } catch (error) {
    console.error('Error formatting date:', error)
    return 'Invalid Date'
  }
}

/**
 * Groups events by formatted date
 */
const groupByDate = (eventsList) => {
  const grouped = {}
  eventsList.forEach(event => {
    if (!event.date) return
    const dateKey = formatDate(event.date)
    if (!grouped[dateKey]) {
      grouped[dateKey] = []
    }
    grouped[dateKey].push(event)
  })
  // Sort events within each group by name
  Object.keys(grouped).forEach(dateKey => {
    grouped[dateKey].sort((a, b) => a.name.localeCompare(b.name))
  })
  return grouped
}

const MyEvents = () => {
  const location = useLocation()
  const [savedEvents, setSavedEvents] = useState([])

  // Load saved events from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem('myEvents')
      if (stored) {
        const data = JSON.parse(stored)
        if (data.savedEvents && Array.isArray(data.savedEvents)) {
          setSavedEvents(data.savedEvents)
        }
      }
    } catch (error) {
      console.error('Failed to load saved events:', error)
    }
  }, [])

  // Group events by date
  const groupedEvents = groupByDate(savedEvents)
  const sortedDates = Object.keys(groupedEvents).sort((a, b) => {
    const dateA = savedEvents.find(e => formatDate(e.date) === a)?.date || ''
    const dateB = savedEvents.find(e => formatDate(e.date) === b)?.date || ''
    return dateA.localeCompare(dateB)
  })

  // Remove event handler
  const handleRemoveEvent = (eventId) => {
    const updated = savedEvents.filter(e => e.id !== eventId)
    setSavedEvents(updated)
    
    try {
      const data = {
        savedEvents: updated,
        lastModified: new Date().toISOString(),
        version: '1.0'
      }
      localStorage.setItem('myEvents', JSON.stringify(data))
    } catch (error) {
      console.error('Failed to save:', error)
    }
  }

  // Clear all handler
  const handleClearAll = () => {
    if (!confirm('Remove all saved events?')) {
      return
    }
    
    setSavedEvents([])
    try {
      const data = {
        savedEvents: [],
        lastModified: new Date().toISOString(),
        version: '1.0'
      }
      localStorage.setItem('myEvents', JSON.stringify(data))
    } catch (error) {
      console.error('Failed to clear:', error)
    }
  }

  // Get tickets handler (same as main page)
  const handleGetTickets = (event) => {
    console.log('Get tickets for:', event)
  }

  return (
    <div className="events-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="background-overlay"></div>
      <header className="events-header">
        <div className="header-left">
          <Link to="/" className="home-link">
            <h1>Events</h1>
          </Link>
          <nav className="main-nav">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' || location.pathname === '/events' || location.pathname === '/events/' ? 'active' : ''}`}
            >
              Events
            </Link>
            <Link 
              to="/my-events" 
              className={`nav-link ${location.pathname === '/my-events' || location.pathname === '/events/my-events' ? 'active' : ''}`}
            >
              My Events
            </Link>
          </nav>
        </div>
        <div className="header-controls">
          <Link to="/" className="btn-secondary">
            ← Back to Events
          </Link>
        </div>
      </header>

      <div className="my-events-wrapper">
        <div className="my-events-header">
          <h2>My Events</h2>
          <p className="my-events-count">
            {savedEvents.length === 0
              ? "You haven't saved any events yet"
              : `You have ${savedEvents.length} saved event${savedEvents.length !== 1 ? 's' : ''}`
            }
          </p>
        </div>

        {savedEvents.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📋</div>
            <p>You haven't saved any events yet</p>
            <p className="empty-subtitle">
              Browse events and click "Save" to add them here
            </p>
            <Link to="/" className="btn primary">
              Browse Events
            </Link>
          </div>
        ) : (
          <>
            <div className="saved-events-list">
              {sortedDates.map(dateKey => (
                <React.Fragment key={dateKey}>
                  <div className="saved-date-header">
                    {dateKey}
                  </div>
                  {groupedEvents[dateKey].map(event => (
                    <div key={event.id} className="saved-event-card">
                      <button
                        className="remove-event-btn"
                        onClick={() => handleRemoveEvent(event.id)}
                        aria-label={`Remove ${event.name}`}
                        title="Remove event"
                      >
                        🗑️
                      </button>
                      <div className="saved-event-content">
                        <h3 className="saved-event-name">{event.name}</h3>
                        <p className="saved-event-venue">{event.venue}</p>
                        <p className="saved-event-address">{event.address}</p>
                        <button
                          className="saved-event-tickets-btn"
                          onClick={() => handleGetTickets(event)}
                        >
                          Get Tickets
                        </button>
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
            
            <div className="clear-all-container">
              <button
                className="btn secondary"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default MyEvents

